module.exports = __webpack_public_path__ + "static/img/71-3.81fc278.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/71-3.jpg
// module id = UEaP
// module chunks = 0